package com.xtream.composeapp.presentation.widget

import com.xtream.composeapp.resources.Res
import com.xtream.composeapp.resources.logo
import com.xtream.composeapp.resources.logo_24
import com.xtream.composeapp.resources.logo_light
import org.jetbrains.compose.resources.DrawableResource

// commonMain
 fun brandLogoResource(usesDarkMode: Boolean=true): DrawableResource {
    // println("987687: ${SharedBuildKonfig.FLAVOR}")
     val resId =
         if(usesDarkMode)
             Res.drawable.logo
         else
             Res.drawable.logo_light

    return resId
}

fun brandIcon24Resource(): DrawableResource {
    return    Res.drawable.logo_24

}